module.exports = __webpack_public_path__ + "img/gy.fcae52f4.svg";